module.exports = __webpack_public_path__ + "img/focus-art.26b0cb1e.jpg";